import React from 'react';
import './paymentForm.css';

const PaymentAuthorizationSection = () => {
  return (
    <div className="payment-form loa-doc-page">
      <h1 className="title">Payment Authorization Form</h1>
      <>
        <p className="strip">Payment Information</p>
        <div className="row">
          <div className="d-flex">
            <p>Payment Method:</p>
            <div className="filled-box" />
            <p>ACH</p>
            <div className="filled-box" />
            <p>Credit Card</p>
          </div>
          <div className="d-flex">
            <p>Monthly Invoice Amount: </p>
            <div className="border-bottom-field width-60" />
          </div>
        </div>
        <div className="row">
          <div className="d-flex">
            <p>Billing Cycle:</p>
            <div className="filled-box" />
            <p>Monthly</p>
            <div className="filled-box" />
            <p>Monthly(AutoPay)</p>
            <div className="filled-box" />
            <p>Annually</p>
          </div>
          <div className="d-flex">
            <p>Annual Invoice Amount: </p>
            <div className="border-bottom-field width-75" />
          </div>
        </div>
      </>
      <>
        <p className="strip">Credit Card Information</p>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Credit Card #: </p>
            <div className="border-bottom-field" style={{ width: '90%' }} />
          </div>
          <div className="d-flex">
            <p>Expiration (Mo/Yr): </p>
            <div className="border-bottom-field width-40" />
            /
            <div className="border-bottom-field width-40" />
            <p>CVV#: </p>
            <div className="border-bottom-field width-50" />
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Card Holder Name: </p>
            <div className="border-bottom-field" style={{ width: '70%' }} />
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Address: </p>
            <div className="border-bottom-field" style={{ width: '90%' }} />
          </div>
          <div className="d-flex">
            <p>Suite/Unit/Apt # </p>
            <div className="border-bottom-field width-50" />
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>City: </p>
            <div className="border-bottom-field" style={{ width: '40%' }} />
            <p>State: </p>
            <div className="border-bottom-field" style={{ width: '30%' }} />
            <p>Zip Code: </p>
            <div className="border-bottom-field" style={{ width: '20%' }} />
          </div>
        </div>
      </>

      <>
        <p className="strip">ACH Information</p>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Bank Name: </p>
            <div className="border-bottom-field" style={{ width: '90%' }} />
          </div>
          <div className="d-flex">
            <p>Account Holder Type (Circle): </p>
            &nbsp;&nbsp;<b>Individual</b>&nbsp;&nbsp; Or&nbsp;&nbsp;
            <b>Company</b>
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Name on Account: </p>
            <div className="border-bottom-field" style={{ width: '65%' }} />
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Account #: </p>
            <div className="border-bottom-field" style={{ width: '70%' }} />
          </div>
        </div>
        <div className="row">
          <div className="d-flex" style={{ flex: 1 }}>
            <p>Routing #: </p>
            <div className="border-bottom-field" style={{ width: '70%' }} />
          </div>
        </div>
      </>
      <>
        <p className="strip">Authorization</p>
        <div className="row">
          <p style={{ whiteSpace: 'break-spaces' }}>
            I understand that this authorization will remain in effect until I cancel it in writing,
            and I agree to notify <span style={{ color: 'blue' }}>Accounting@Epik.io</span> in
            writing of any changes in my account information or termination of this authorization at
            least 15 days prior to the next billing date. If the above noted payment dates fall on a
            weekend or holiday, I understand that the payments may be executed on the next business
            day. I acknowledge that the origination of Credit Card/ACH transactions to my account
            must comply with the provisions of U.S. law. I certify that I am an authorized user of
            this Credit Card/ACH and will not dispute these scheduled transactions; so long as the
            transactions correspond to the terms indicated in this authorization form.
          </p>
        </div>
      </>

      <div className="row my-40">
        <div className="d-flex" style={{ flex: 1 }}>
          <p>SIGNATURE</p>
          <div className="signature-div">
            <div className="border-bottom-field" style={{ width: '100%' }} />
            <p>(Authorized Personnel Signature)</p>
          </div>
        </div>
        <div className="d-flex" style={{ flex: 1 }}>
          <p>DATE</p>
          <div className="border-bottom-field" style={{ width: '30%' }} />
        </div>
      </div>
      <p className="payment-caption">Epik provided by OBSM, LLC. Copyright 2019</p>
    </div>
  );
};

export default PaymentAuthorizationSection;
